import { Capacitor } from '@capacitor/core';

export const registerDeepLinkListener = async () => {
  if (!Capacitor.isNativePlatform()) return;

  // App 모듈은 네이티브 플랫폼에서만 필요하므로 동적 import
  const { App } = await import('@capacitor/app');

  App.addListener('appUrlOpen', async ({ url }) => {
    if (!url || !url.startsWith('tubedigest://auth')) return;
    try {
      const parsed = new URL(url);
      const token = parsed.searchParams.get('token');
      if (token) {
        // 저장 방식: localStorage (필요 시 Cookie 로 변경)
        localStorage.setItem('td_token', token);
      }
      // 홈으로 리로드하여 로그인 세션 적용
      window.location.href = '/';
      // 열린 In-App Browser 닫기 시도
      try {
        const { Browser } = await import('@capacitor/browser');
        await Browser.close();
      } catch (e) {
        console.warn('Browser close 실패(무시 가능)', e);
      }
    } catch (e) {
      console.error('딥링크 파싱 오류', e);
    }
  });
}; 